/**
 * OpenUI chrome tokens
 *
 * Apple-esque generative UI: one surface, hairlines, no nested cards.
 * Motion stays GPU-only (transform / opacity) — GodUI contract.
 */

export const openUISurfaceClass =
  'my-2 w-full overflow-hidden rounded-[18px] bg-background/40 px-1 py-1 backdrop-blur-[6px] supports-[backdrop-filter]:bg-background/30'

export const openUISectionClass = 'flex w-full flex-col gap-3'

export const openUITitleClass =
  'text-[13px] font-semibold tracking-[-0.01em] text-foreground'

export const openUISubtitleClass =
  'text-[12px] leading-5 text-muted-foreground'

export const openUIMetricClass =
  'min-w-[7.5rem] flex-1 px-1 py-1.5'

export const openUIRowClass =
  'flex w-full items-center justify-between gap-3 border-b border-border/40 px-1 py-2.5 last:border-b-0 motion-safe:transition-[opacity,transform] motion-safe:duration-150 hover:opacity-90'

export const openUIPanelClass =
  'flex w-full flex-col gap-2'

export const openUIEnterClass =
  'motion-safe:animate-[openui-enter_280ms_cubic-bezier(0.16,1,0.3,1)_both] motion-reduce:animate-none'

export const OPENUI_ENTER_KEYFRAMES = `
@keyframes openui-enter {
  from {
    opacity: 0;
    transform: translateY(6px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
`
